import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const NewContentHistory: LoadableType<{
	contentId: string;
	spaceKey: string;
	contentType?: string;
	ClassicEditorContextProviderLoader?: React.ComponentType<any>;
	version1?: number;
	version2?: number;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NewContentHistory" */ '../src/NewContentHistory.tsx'
			)
		).NewContentHistory,
});
